export const AlgoliaSiteWideSearchIndex = 'SiteWideSearch';
export const AlgoliaClickEventName = 'Search Result Clicked';

export const SearchMaximumPaginationResults = 200;

export const SearchMinimumCharacterLength = 3;
export const SearchMaximumCharacterLength = 500;
